<script setup lang="ts">
import { useBannerStore } from '@/store/banner'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const { warningText, errorText, successText, newMappedRemedy } =
  storeToRefs(useBannerStore())

// Safari needs a persistent sr-only element with changing text to announce live regions reliably.
// Lives inside aria-modal dialogs too, since those prune the global announcer from the a11y tree.
const announcementText = computed(() => {
  if (warningText.value) return warningText.value
  if (errorText.value) return errorText.value
  if (successText.value) return successText.value
  if (newMappedRemedy.value) return 'Notification'
  return ''
})
</script>

<template>
  <span class="sr-only" aria-live="assertive" aria-atomic="true">{{
    announcementText
  }}</span>
</template>
